import type { SupabaseClient } from "@supabase/supabase-js"

// "I am here": bumps profiles.last_active_at through touch_last_active()
// (scripts/1064-talent-activity.sql), which the hiring talent list uses to put
// the most active barbers first. Called when a signed-in session loads and
// when the tab comes back into view.
//
// Throttled twice: here, so a tab flicking in and out does not call at all,
// and in the function, which only writes when the last write is 10+ minutes
// old. Fire and forget. Before 1064 is run the RPC does not exist, and that is
// fine: nothing waits on it and nothing is shown.

const KEY = "booth:last-active-ping"
const EVERY_MS = 10 * 60 * 1000

export function pingActive(supabase: SupabaseClient, userId: string) {
  try {
    const raw = localStorage.getItem(KEY)
    const [lastUser, lastAt] = raw ? raw.split("|") : []
    if (lastUser === userId && Date.now() - Number(lastAt || 0) < EVERY_MS) return
    localStorage.setItem(KEY, `${userId}|${Date.now()}`)
  } catch {
    // Storage blocked: fall through and let the database throttle.
  }
  void supabase.rpc("touch_last_active").then(
    () => {},
    () => {},
  )
}
